import {NgModule} from '@angular/core';
import {HasPermissionDirective} from './has-permission.directive';
import {PhoneNumbersStringDirective} from './phone-numbers-string.directive';
import {NumbersStringDirective} from './numbers-string.directive';

@NgModule({
    declarations: [
        HasPermissionDirective,
        PhoneNumbersStringDirective,
        NumbersStringDirective
    ],
    exports: [
        HasPermissionDirective,
        PhoneNumbersStringDirective,
        NumbersStringDirective
    ]
})
export class DirectiveModule {
}
